import { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import {ArrowLeftOutlined} from '@ant-design/icons';

import InvoicePreviewPopup from './components/InvoicePreviewPopup';
import Table from '../../components/ui/Table';
import {invoicesTableConfigAwaitingPaiment} from './config/invoicesTableConfigAwaitingPaiment';
import InvoicePaiementPopup from './components/InvoicePaiementPopup';

const InvoicesAwaitingPaymentPage = ({
    data,
    userData,
    refreshData,
    filterInvoicesList,
    tableType,
    paginationMetadata,
    onPageNumberChange,
    tableLoading
}) => {
    const [itemSelected, setItemSelected] = useState(null);
    const [showInvoicePreviewPopup, setShowInvoicePreviewPopup] = useState(false);
    const [showInvoicePaiementPopup, setShowInvoicePaiementPopup] = useState(false);
    
    useEffect(() => {
        if (!showInvoicePreviewPopup && !showInvoicePaiementPopup) {
            setItemSelected(null);
        }
    }, [showInvoicePreviewPopup, showInvoicePaiementPopup]);

    const handleInvoicePreview = (item) => {
        setItemSelected(item);
        setShowInvoicePreviewPopup(true);
    }

    const handleInvoicePaiement = (item) => {
        setItemSelected(item);
        setShowInvoicePaiementPopup(true);
    }

    const tableConfig = invoicesTableConfigAwaitingPaiment({
        handleInvoicePreview,
        handleInvoicePaiement,
        filterInvoicesList,
        tableType,
        userData
    });

    return (
        <>
            <div className='flex items-center justify-between my-10'>
                <Link to='/dashboard/office-manager'>
                    <ArrowLeftOutlined style={{fontSize: '25px'}}/>
                </Link>
                <h1
                    className='text-3xl font-bold'
                    style={{fontFamily: 'DIN Condensed'}}
                >
                    {`Factures en attente de paiement (${paginationMetadata.totalItems})`}
                </h1>
                <div/>
            </div>
            
            <Table
                data={data}
                tableConfig={tableConfig}
                paginationMetadata={paginationMetadata}
                onPageNumberChange={onPageNumberChange}
                loading={tableLoading}
            />

            <InvoicePreviewPopup
                view={showInvoicePreviewPopup}
                setView={setShowInvoicePreviewPopup}
                item={itemSelected}
                type='invoice'
            />

            <InvoicePaiementPopup
                view={showInvoicePaiementPopup}
                setView={setShowInvoicePaiementPopup}
                item={itemSelected}
                userData={userData}
                refreshData={refreshData}
            />
        </>
    )
}

export default InvoicesAwaitingPaymentPage;
